import { __awaiter, __generator } from "tslib";
import { writable } from "svelte/store";
function createStatsStore() {
    var _this = this;
    var _a = writable({
        eventBus: null,
        organisations: [],
        creativeStats: [],
        stationStats: [],
        organisationStats: {
            playouts: 0,
            impressions: 0,
            turnover: 0,
            potentialImpressions: 0,
            potentialPlayouts: 0,
            potentialTurnover: 0,
            timeRangeBuckets: []
        }
    }), subscribe = _a.subscribe, set = _a.set, update = _a.update;
    return {
        subscribe: subscribe,
        update: update,
        subscribeToChannel: function (statsStore, channel, handler) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                statsStore.eventBus.registerHandler(channel, handler);
                return [2 /*return*/];
            });
        }); }
    };
}
export var statsStore = createStatsStore();
